<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />
        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Bootstrap Modals</h4>

                <p>
                  A rendered modal with header, body, and set of actions in the footer.
                </p>

                <!-- Standard modal content -->
                <div
                  id="standard-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="standard-modalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="standard-modalLabel">
                          Modal Heading
                        </h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <h6>Text in a modal</h6>
                        <p>
                          Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                        </p>
                        <hr />
                        <h6>Overflowing text to show scroll behavior</h6>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                      </div>
                      <div class="modal-footer">
                        <b-button variant="light me-1" data-bs-dismiss="modal">
                          Close
                        </b-button>
                        <b-button variant="primary"> Save changes </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!--  Modal content for the Large example -->
                <div
                  class="modal fade"
                  id="bs-example-modal-lg"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myLargeModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="myLargeModalLabel">Large modal</h4>
                        <b-button
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">...</div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <div
                  class="modal fade"
                  id="bs-example-modal-sm"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="mySmallModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="mySmallModalLabel">Small modal</h4>
                        <b-button
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">...</div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Full width modal content -->
                <div
                  id="full-width-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="fullWidthModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-full-width">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="fullWidthModalLabel">
                          Modal Heading
                        </h4>
                        <b-button
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <h6>Text in a modal</h6>
                        <p>
                          Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                        </p>
                        <hr />
                        <h6>Overflowing text to show scroll behavior</h6>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                      </div>
                      <div class="modal-footer">
                        <b-button variant="light me-1" data-bs-dismiss="modal">
                          Close
                        </b-button>
                        <b-button variant="-primary"> Save changes </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Long Content Scroll Modal -->
                <div
                  class="modal fade"
                  id="scrollable-modal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="scrollableModalTitle"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="scrollableModalTitle">Modal title</h5>
                        <b-button
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                        <p>
                          Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
                          cursus magna, vel scelerisque nisl consectetur et. Donec sed
                          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                        </p>
                      </div>
                      <div class="modal-footer">
                        <b-button variant="secondary me-1" data-bs-dismiss="modal">
                          Close
                        </b-button>
                        <b-button variant="primary"> Save changes </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <div class="button-list">
                  <!-- Standard  modal -->
                  <b-button
                    variant="primary mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#standard-modal"
                  >
                    Standard Modal
                  </b-button>
                  <!-- Large modal -->
                  <b-button
                    variant="info mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#bs-example-modal-lg"
                  >
                    Large Modal
                  </b-button>
                  <!-- Small modal -->
                  <b-button
                    variant="success mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#bs-example-modal-sm"
                  >
                    Small Modal
                  </b-button>
                  <!-- Full width modal -->
                  <b-button
                    variant="primary mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#full-width-modal"
                  >
                    Full width Modal
                  </b-button>
                  <!-- Scrollable modal -->
                  <b-button
                    variant="secondary mt-1"
                    data-bs-toggle="modal"
                    data-bs-target="#scrollable-modal"
                  >
                    Scrollable Modal
                  </b-button>
                </div>
              </div>
              <!-- end card-body card-buttons -->
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->

          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Modal with Pages</h4>
                <p>Examples of custom modals.</p>

                <!-- Signup modal content -->
                <div
                  id="signup-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div class="text-center mt-2 mb-4">
                          <div class="auth-logo">
                            <router-link to="index" class="logo logo-dark">
                              <span class="logo-lg">
                                <img
                                  src="../../../../assets/img/logo.png"
                                  alt=""
                                  height="42"
                                />
                              </span>
                            </router-link>
                          </div>
                        </div>

                        <form class="px-3" action="#">
                          <div class="mb-3">
                            <label for="username" class="form-label">Name</label>
                            <input
                              class="form-control"
                              type="email"
                              id="username"
                              placeholder="Michael Zenaty"
                            />
                          </div>

                          <div class="mb-3">
                            <label for="emailaddress" class="form-label"
                              >Email address</label
                            >
                            <input
                              class="form-control"
                              type="email"
                              id="emailaddress"
                              placeholder="john@deo.com"
                            />
                          </div>

                          <div class="mb-3">
                            <label for="password" class="form-label">Password</label>
                            <input
                              class="form-control"
                              type="password"
                              id="password"
                              placeholder="Enter your password"
                            />
                          </div>

                          <div class="mb-3">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="customCheck1"
                              />
                              <label class="form-check-label" for="customCheck1"
                                >I accept
                                <a href="javascript:;">Terms and Conditions</a></label
                              >
                            </div>
                          </div>

                          <div class="mb-3 text-center">
                            <b-button variant="primary" type="submit">
                              Sign Up Free
                            </b-button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- SignIn modal content -->
                <div
                  id="login-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div class="text-center mt-2 mb-4">
                          <div class="auth-logo">
                            <router-link to="index" class="logo logo-dark">
                              <span class="logo-lg">
                                <img
                                  src="../../../../assets/img/logo.png"
                                  alt=""
                                  height="42"
                                />
                              </span>
                            </router-link>
                          </div>
                        </div>

                        <form action="#" class="px-3">
                          <div class="mb-3">
                            <label for="emailaddress1" class="form-label"
                              >Email address</label
                            >
                            <input
                              class="form-control"
                              type="email"
                              id="emailaddress1"
                              placeholder="john@deo.com"
                            />
                          </div>

                          <div class="mb-3">
                            <label for="password1" class="form-label">Password</label>
                            <input
                              class="form-control"
                              type="password"
                              id="password1"
                              placeholder="Enter your password"
                            />
                          </div>

                          <div class="mb-3">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="customCheck2"
                              />
                              <label class="form-check-label" for="customCheck2"
                                >Remember me</label
                              >
                            </div>
                          </div>

                          <div class="mb-2 text-center">
                            <b-button pill variant="primary" type="submit">
                              Sign In
                            </b-button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <div class="button-list">
                  <!-- Sign Up modal -->
                  <b-button
                    variant="primary mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#signup-modal"
                  >
                    Sign Up Modal
                  </b-button>
                  <!-- Log In modal -->
                  <b-button
                    variant="info mt-1"
                    data-bs-toggle="modal"
                    data-bs-target="#login-modal"
                  >
                    Log In Modal
                  </b-button>
                </div>
              </div>
              <!-- end card-body card-buttons -->
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Modal Position</h4>
                <p>
                  Specify the position for the modal. You can display modal at top,
                  bottom, center or right of page by specifying classes
                  <code>modal-top</code>, <code>modal-bottom</code>,
                  <code>modal-dialog-centered</code> and
                  <code>modal-right </code> respectively.
                </p>

                <!-- Top modal content -->
                <div
                  id="top-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-top">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="topModalLabel">Modal Heading</h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <h5>Text in a modal</h5>
                        <p>
                          Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                        </p>
                      </div>
                      <div class="modal-footer">
                        <b-button variant="light me-1" data-bs-dismiss="modal">
                          Close
                        </b-button>
                        <b-button variant="primary"> Save changes </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Right modal content -->
                <div
                  id="right-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm modal-right">
                    <div class="modal-content">
                      <div class="modal-header border-0">
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <div class="text-center">
                          <h4 class="mt-0">Text in a modal</h4>
                          <p>
                            Duis mollis, est non commodo luctus, nisi erat porttitor
                            ligula.
                          </p>
                          <b-button variant="danger btn-sm" data-bs-dismiss="modal">
                            Close
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Bottom modal content -->
                <div
                  id="bottom-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm modal-bottom">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="bottomModalLabel">Modal Heading</h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <h5>Text in a modal</h5>
                        <p>
                          Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                        </p>
                      </div>
                      <div class="modal-footer">
                        <b-button variant="light me-1" data-bs-dismiss="modal">
                          Close
                        </b-button>
                        <b-button variant="primary"> Save changes </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Center modal content -->
                <div
                  class="modal fade"
                  id="centermodal"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="myCenterModalLabel">Center modal</h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        <h5>Overflowing text to show scroll behavior</h5>
                        <p>
                          Cras mattis consectetur purus sit amet fermentum. Cras justo
                          odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                          risus, porta ac consectetur ac, vestibulum at eros.
                        </p>
                        <p>
                          Praesent commodo cursus magna, vel scelerisque nisl consectetur
                          et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                          dolor auctor.
                        </p>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <div class="button-list">
                  <!-- Top modal -->
                  <b-button
                    type="button"
                    class="btn btn-secondary mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#top-modal"
                  >
                    Top Modal
                  </b-button>
                  <!-- Bottom modal -->
                  <b-button
                    variant="secondary mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#bottom-modal"
                  >
                    Bottom Modal
                  </b-button>
                  <!-- Center modal -->
                  <b-button
                    variant="secondary mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#centermodal"
                  >
                    Center modal
                  </b-button>
                  <!-- Right modal -->
                  <b-button
                    variant="secondary mt-1"
                    data-bs-toggle="modal"
                    data-bs-target="#right-modal"
                  >
                    Rightbar Modal
                  </b-button>
                </div>
              </div>
              <!-- end card-body card-buttons -->
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->

          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Modal based Alerts</h4>
                <p>Show different contexual alert messages using modal component</p>

                <!-- Success Alert Modal -->
                <div
                  id="success-alert-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm">
                    <div class="modal-content modal-filled bg-success">
                      <div class="modal-body p-4">
                        <div class="text-center">
                          <i class="dripicons-checkmark h1 text-white"></i>
                          <h4 class="mt-2 text-white">Well Done!</h4>
                          <p class="mt-3 text-white">
                            Cras mattis consectetur purus sit amet fermentum. Cras justo
                            odio, dapibus ac facilisis in, egestas eget quam.
                          </p>
                          <b-button variant="light my-2" data-bs-dismiss="modal">
                            Continue
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Info Alert Modal -->
                <div
                  id="info-alert-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm">
                    <div class="modal-content">
                      <div class="modal-body p-4">
                        <div class="text-center">
                          <i class="dripicons-information h1 text-info"></i>
                          <h4 class="mt-2">Heads up!</h4>
                          <p class="mt-3">
                            Cras mattis consectetur purus sit amet fermentum. Cras justo
                            odio, dapibus ac facilisis in, egestas eget quam.
                          </p>
                          <b-button variant="info my-2" data-bs-dismiss="modal">
                            Continue
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Warning Alert Modal -->
                <div
                  id="warning-alert-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm">
                    <div class="modal-content">
                      <div class="modal-body p-4">
                        <div class="text-center">
                          <i class="dripicons-warning h1 text-warning"></i>
                          <h4 class="mt-2">Incorrect Information</h4>
                          <p class="mt-3">
                            Cras mattis consectetur purus sit amet fermentum. Cras justo
                            odio, dapibus ac facilisis in, egestas eget quam.
                          </p>
                          <b-button variant="warning my-2" data-bs-dismiss="modal">
                            Continue
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Danger Alert Modal -->
                <div
                  id="danger-alert-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-sm">
                    <div class="modal-content modal-filled bg-danger">
                      <div class="modal-body p-4">
                        <div class="text-center">
                          <i class="dripicons-wrong h1 text-white"></i>
                          <h4 class="mt-2 text-white">Oh snap!</h4>
                          <p class="mt-3 text-white">
                            Cras mattis consectetur purus sit amet fermentum. Cras justo
                            odio, dapibus ac facilisis in, egestas eget quam.
                          </p>
                          <b-button variant="light my-2" data-bs-dismiss="modal">
                            Continue
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <div class="button-list">
                  <!-- Success Alert modal -->
                  <b-button
                    variant="success mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#success-alert-modal"
                  >
                    Success Alert
                  </b-button>
                  <!-- Info Alert modal -->
                  <b-button
                    variant="info mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#info-alert-modal"
                  >
                    Info Alert
                  </b-button>
                  <!-- Warning Alert modal -->
                  <b-button
                    variant="warning mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#warning-alert-modal"
                  >
                    Warning Alert
                  </b-button>
                  <!-- Danger Alert modal -->
                  <b-button
                    variant="danger mt-1"
                    data-bs-toggle="modal"
                    data-bs-target="#danger-alert-modal"
                  >
                    Danger Alert
                  </b-button>
                </div>
              </div>
              <!-- end card-body card-buttons -->
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Multiple Modal</h4>
                <p>
                  Display a series of modals one by one to guide your users on multiple
                  aspects or take step wise input.
                </p>

                <!-- Modal -->
                <div
                  class="modal fade"
                  id="exampleModalToggle"
                  aria-hidden="true"
                  aria-labelledby="exampleModalToggleLabel"
                  tabindex="-1"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="exampleModalToggleLabel">Modal 1</h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        Show a second modal and hide this one with the button below.
                      </div>
                      <div class="modal-footer">
                        <b-button
                          variant="primary"
                          data-bs-target="#exampleModalToggle2"
                          data-bs-toggle="modal"
                          data-bs-dismiss="modal"
                        >
                          Open second modal
                        </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <!-- Modal -->
                <div
                  class="modal fade"
                  id="exampleModalToggle2"
                  aria-hidden="true"
                  aria-labelledby="exampleModalToggleLabel2"
                  tabindex="-1"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="exampleModalToggleLabel2">Modal 2</h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        Hide this modal and show the first with the button below.
                      </div>
                      <div class="modal-footer">
                        <b-button
                          variant="primary"
                          data-bs-target="#exampleModalToggle"
                          data-bs-toggle="modal"
                          data-bs-dismiss="modal"
                        >
                          Back to first
                        </b-button>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <a
                  class="btn btn-secondary"
                  data-bs-toggle="modal"
                  href="#exampleModalToggle"
                  role="button"
                  >Open first modal</a
                >
              </div>
              <!-- end card-body card-buttons -->
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->

          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Custom Modals</h4>

                <p>Examples of custom modals.</p>

                <!-- sample modal content -->

                <div
                  id="con-close-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myModalLabel"
                  aria-hidden="true"
                  style="display: none"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title">Modal Content is Responsive</h4>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body p-4">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label for="field-1" class="form-label">Name</label>
                              <input
                                type="text"
                                class="form-control"
                                id="field-1"
                                placeholder="John"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label for="field-2" class="form-label">Surname</label>
                              <input
                                type="text"
                                class="form-control"
                                id="field-2"
                                placeholder="Doe"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="mb-3">
                              <label for="field-3" class="form-label">Address</label>
                              <input
                                type="text"
                                class="form-control"
                                id="field-3"
                                placeholder="Address"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="mb-3">
                              <label for="field-4" class="form-label">City</label>
                              <input
                                type="text"
                                class="form-control"
                                id="field-4"
                                placeholder="Boston"
                              />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="mb-3">
                              <label for="field-5" class="form-label">Country</label>
                              <input
                                type="text"
                                class="form-control"
                                id="field-5"
                                placeholder="United States"
                              />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="mb-3">
                              <label for="field-6" class="form-label">Zip</label>
                              <input
                                type="text"
                                class="form-control"
                                id="field-6"
                                placeholder="123456"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="">
                              <label for="field-7" class="form-label"
                                >Personal Info</label
                              >
                              <textarea
                                class="form-control"
                                id="field-7"
                                placeholder="Write something about yourself"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <b-button
                          variant="secondary waves-effect me-1"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </b-button>
                        <b-button variant="info waves-effect waves-light">
                          Save changes
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.modal -->

                <div
                  id="accordion-modal"
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myModalLabel"
                  aria-hidden="true"
                  style="display: none"
                >
                  <div class="modal-dialog">
                    <div class="modal-content p-0">
                      <div id="accordion">
                        <div class="card mb-0">
                          <div class="card-header" id="headingOne">
                            <h5 class="m-0">
                              <a
                                href="#collapseOne"
                                class="text-dark"
                                data-bs-toggle="collapse"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                Collapsible Group Item #1
                              </a>
                            </h5>
                          </div>

                          <div
                            id="collapseOne"
                            class="collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordion"
                          >
                            <div class="card-body card-buttons">
                              Anim pariatur cliche reprehenderit, enim eiusmod high life
                              accusamus terry richardson ad squid. 3 wolf moon officia
                              aute, non cupidatat skateboard dolor brunch. Food truck
                              quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                              sunt aliqua put a bird on it squid single-origin coffee
                              nulla assumenda shoreditch et. Nihil anim keffiyeh
                              helvetica, craft beer labore wes anderson cred nesciunt
                              sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                              Leggings occaecat craft beer farm-to-table, raw denim
                              aesthetic synth nesciunt you probably haven't heard of them
                              accusamus labore sustainable VHS.
                            </div>
                          </div>
                        </div>
                        <div class="card mb-0">
                          <div class="card-header" id="headingTwo">
                            <h5 class="m-0">
                              <a
                                href="#collapseTwo"
                                class="collapsed text-dark"
                                data-bs-toggle="collapse"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                              >
                                Collapsible Group Item #2
                              </a>
                            </h5>
                          </div>
                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordion"
                          >
                            <div class="card-body card-buttons">
                              Anim pariatur cliche reprehenderit, enim eiusmod high life
                              accusamus terry richardson ad squid. 3 wolf moon officia
                              aute, non cupidatat skateboard dolor brunch. Food truck
                              quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                              sunt aliqua put a bird on it squid single-origin coffee
                              nulla assumenda shoreditch et. Nihil anim keffiyeh
                              helvetica, craft beer labore wes anderson cred nesciunt
                              sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                              Leggings occaecat craft beer farm-to-table, raw denim
                              aesthetic synth nesciunt you probably haven't heard of them
                              accusamus labore sustainable VHS.
                            </div>
                          </div>
                        </div>
                        <div class="card mb-0">
                          <div class="card-header" id="headingThree">
                            <h5 class="m-0">
                              <a
                                href="#collapseThree"
                                class="collapsed text-dark"
                                data-bs-toggle="collapse"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                              >
                                Collapsible Group Item #3
                              </a>
                            </h5>
                          </div>
                          <div
                            id="collapseThree"
                            class="collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordion"
                          >
                            <div class="card-body card-buttons">
                              Anim pariatur cliche reprehenderit, enim eiusmod high life
                              accusamus terry richardson ad squid. 3 wolf moon officia
                              aute, non cupidatat skateboard dolor brunch. Food truck
                              quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                              sunt aliqua put a bird on it squid single-origin coffee
                              nulla assumenda shoreditch et. Nihil anim keffiyeh
                              helvetica, craft beer labore wes anderson cred nesciunt
                              sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                              Leggings occaecat craft beer farm-to-table, raw denim
                              aesthetic synth nesciunt you probably haven't heard of them
                              accusamus labore sustainable VHS.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->

                <div class="button-list">
                  <!-- Responsive modal -->
                  <b-button
                    variant="success waves-effect waves-light mt-1 me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#con-close-modal"
                  >
                    Responsive Modal
                  </b-button>
                  <!-- Accordion modal -->
                  <b-button
                    variant="secondary waves-effect waves-light mt-1"
                    data-bs-toggle="modal"
                    data-bs-target="#accordion-modal"
                  >
                    Accordion in Modal
                  </b-button>
                </div>
              </div>
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body card-buttons">
                <h4 class="header-title">Static backdrop</h4>

                <p>
                  When backdrop is set to static, the modal will not close when clicking
                  outside it. Click the button below to try it.
                </p>

                <b-button
                  variant="primary"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  Launch static backdrop modal
                </b-button>

                <!-- Modal -->
                <div
                  class="modal fade"
                  id="staticBackdrop"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">Modal title</h5>
                        <b-button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></b-button>
                      </div>
                      <div class="modal-body">
                        Anim pariatur cliche reprehenderit, enim eiusmod high life
                        accusamus terry richardson ad squid. 3 wolf moon officia aute, non
                        cupidatat skateboard dolor brunch. Food truck quinoa nesciunt
                        laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird
                        on it squid single-origin coffee nulla assumenda shoreditch et.
                      </div>
                      <div class="modal-footer">
                        <b-button variant="secondary" data-bs-dismiss="modal">
                          Close
                        </b-button>
                        <b-button variant="primary">Understood</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script>
export default {
  data() {
    return {
      title: "Modal",
    };
  },
};
</script>
